import { useInfiniteQuery } from '@northladder/services';

import { INV_MGMT_SERVICE_API } from '../../../InventoryManagementClient';
import { ISearchTrayPackagesPayload } from '../../../types';

/**
 * This is to track the Inbound details from the backend.
 */
const INBOUND_POD_INVENTORY_LIST_KEY = 'inbound-pod-inventory-list-query';

/**
 * This is the hook to fetch the tray packages list from the backend.
 */
export const useFetchTrayPackageList = (
  payload: ISearchTrayPackagesPayload
) => {
  const { limit, trayId, search, ageFilter } = payload;
  const {
    data,
    error,
    fetchNextPage,
    hasNextPage,
    isError,
    isFetching,
    isFetchingNextPage,
    isPending,
    refetch,
  } = useInfiniteQuery({
    enabled: !!trayId,
    // eslint-disable-next-line @tanstack/query/exhaustive-deps
    queryKey: [
      INBOUND_POD_INVENTORY_LIST_KEY,
      limit,
      trayId,
      search,
      ageFilter,
    ],
    networkMode: 'always',
    initialPageParam: 1,
    queryFn: ({ pageParam = 1 }) =>
      INV_MGMT_SERVICE_API.getTrayPackages({
        ...payload,
        page: pageParam,
      }),
    getNextPageParam: (lastPage, allPages) => {
      const nextPage = allPages.length + 1;
      const currentCount = allPages.length * limit;

      return currentCount < lastPage.total ? nextPage : undefined;
    },
  });

  return {
    fetchNextPage,
    hasNextPage,
    isFetching,
    isFetchingNextPage,
    isTrayPackagesFetchingError: isError,
    isTrayPackagesLoading: isPending,
    trayPackageData: data,
    trayPackagesFetchError: error,
    refetchTrayPackagesList: refetch,
  };
};
